import { Controller, Post, Body } from '@nestjs/common';
import { ApiBody, ApiTags } from '@nestjs/swagger';
import { WarehouseService } from './warehouse.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { StockInRequestDto } from './dto/stock-in.request.dto';
import { MontlyMisInfoReq, ProductReq, StockInResponseData } from '@gtpl/shared-models/analytics-data';
import { CommonResponse, ContainerWiseAbstractReq, ContainerWiseAbstractResponseModel, DaywiseAnalysisResponseModel, DayWiseProductionReq, DaywiseProductionResponseModel, ExpectedStockInOutResponse, JobIdRequest, LotWiseInfoResponseModel, MonthWiseShrimpReq, PlantIdRequest, ProductAnalysisReq, ProductAnalysisResponseModel, ProductSummaryReportReq, SPSAStockValuationReq, StockSTatementReq, StockStatementResponseModel, StockValuationResponseModel } from '@gtpl/shared-models/warehouse-management'
import { AnalyticsUnitRequest } from './dto/analytics-unit.request';
import { DateFilter, UnitRequest } from '@gtpl/shared-models/common-models';
import { LotCodeDropDown } from '@gtpl/shared-models/production-management';
import { BaleReq } from '@gtpl/shared-models/raw-material-procurement';
@ApiTags('Warehouse')
@Controller('warehouse')
export class WarehouseController {
    constructor(private  warehouseService: WarehouseService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler){}

    @Post('/getStockInfo')
    async getStockInfo(@Body() dtoObj: StockInRequestDto): Promise <StockInResponseData> {
        try {
            return await this.warehouseService.getStockInfo(dtoObj);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(StockInResponseData, Error);
        }
    }

    @Post('/getTodaysStockOutSOs')
    async getTodaysStockOutSOs(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getTodaysStockOutSOs(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getrecentFiveStockIns')
    async getrecentFiveStockIns(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getrecentFiveStockIns(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getrecentFiveStockOuts')
    async getrecentFiveStockOuts(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getrecentFiveStockOuts(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getTodayStockTransfers')
    async getTodayStockTransfers(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getTodayStockTransfers(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getCartonsInWayRacks')
    async getCartonsInWayRacks(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getCartonsInWayRacks(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getLongRunningDummyStock')
    async getLongRunningDummyStock(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getLongRunningDummyStock(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getWarehouseCapacity')
    async getWarehouseCapacity(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getWarehouseCapacity(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getPOsProductionAbove70Perc')
    async getPOsProductionAbove70Perc(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getPOsProductionAbove70Perc(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getTransferdSOsStock')
    async getTransferdSOsStock(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getTransferdSOsStock(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getRepackingEfficiency')
    async getRepackingEfficiency(@Body() req:AnalyticsUnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getRepackingEfficiency(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getExpectedStockInsAndStockOuts')
    async getExpectedStockInsAndStockOuts(@Body() req:AnalyticsUnitRequest): Promise <ExpectedStockInOutResponse> {
        try {
            return await this.warehouseService.getExpectedStockInsAndStockOuts(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getWarehouseLifeCycle')
    async getWarehouseLifeCycle(@Body() req:AnalyticsUnitRequest): Promise <ExpectedStockInOutResponse> {
        try {
            return await this.warehouseService.getWarehouseLifeCycle(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getTop10DummyProducts')
    async getTop10DummyProducts(@Body() req:AnalyticsUnitRequest): Promise <ExpectedStockInOutResponse> {
        try {
            return await this.warehouseService.getTop10DummyProducts(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getStockValuationReport')
    async getStockValuationReport(@Body() req:ProductReq): Promise <StockValuationResponseModel> {
        try {
            return await this.warehouseService.getStockValuationReport(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(StockValuationResponseModel, Error);
        }
    }

    @Post('/getVarientCodeDropdown')
    async getVarientCodeDropdown(): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getVarientCodeDropdown();
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getStockStatementInfo')
    async getStockStatementInfo(@Body() req:StockSTatementReq): Promise <StockStatementResponseModel> {
        try {
            return await this.warehouseService.getStockStatementInfo(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(StockStatementResponseModel, Error);
        }
    }

    @Post('/getProductionAnalysisInfo')
    async getProductionAnalysisInfo(@Body() req:ProductAnalysisReq): Promise <ProductAnalysisResponseModel> {
        try {
            return await this.warehouseService.getProductionAnalysisInfo(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(ProductAnalysisResponseModel, Error);
        }
    }

    @Post('/getDayWiseProdcutionReport')
    async getDayWiseProdcutionReport(@Body() req:ProductAnalysisReq): Promise <DaywiseProductionResponseModel> {
        try {
            return await this.warehouseService.getDayWiseProdcutionReport(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(DaywiseProductionResponseModel, Error);
        }
    }

    @Post('/getTodayStockInInfo')
    async getTodayStockInInfo(@Body() req:UnitRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getTodayStockInInfo(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getReportedQtyAgainstJob')
    async getReportedQtyAgainstJob(req:JobIdRequest): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getReportedQtyAgainstJob(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getContainerWiseAbstract')
    async getContainerWiseAbstract(@Body() req:ContainerWiseAbstractReq): Promise <ContainerWiseAbstractResponseModel> {
        try {
            return await this.warehouseService.getContainerWiseAbstract(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(ContainerWiseAbstractResponseModel, Error);
        }
    }

    @Post('/updateProductionCostAnalysis')
    async updateProductionCostAnalysis(): Promise <CommonResponse> {
        try {
            return await this.warehouseService.updateProductionCostAnalysis();
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/updateRmPurchaseAnalysis')
    async updateRmPurchaseAnalysis(): Promise <CommonResponse> {
        try {
            return await this.warehouseService.updateRmPurchaseAnalysis();
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getDayWiseAnalysisReport')
    async getDayWiseAnalysisReport(@Body() req : DayWiseProductionReq): Promise <DaywiseAnalysisResponseModel> {
        try {
            return await this.warehouseService.getDayWiseAnalysisReport(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(DaywiseAnalysisResponseModel, Error);
        }
    }

    @Post('/getDaywiseProductionExcelInfo')
    async getDaywiseProductionExcelInfo(@Body() req : DayWiseProductionReq): Promise <DaywiseProductionResponseModel> {
        try {
            return await this.warehouseService.getDaywiseProductionExcelInfo(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(DaywiseProductionResponseModel, Error);
        }
    }

    
    @Post('/updateDaywiseOpeningStockInfo')
    async updateDaywiseOpeningStockInfo(): Promise <CommonResponse> {
        try {
            return await this.warehouseService.updateDaywiseOpeningStockInfo();
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/updateDaywiseShrimpAnalysisInfo')
    async updateDaywiseShrimpAnalysisInfo(): Promise <CommonResponse> {
        try {
            return await this.warehouseService.updateDaywiseShrimpAnalysisInfo();
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    
    @Post('/getMonthlyShrimpMISReport')
    async getMonthlyShrimpMISReport(@Body() req:MonthWiseShrimpReq): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getMonthlyShrimpMISReport(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getShippedContainerMISDetails')
    async getShippedContainerMISDetails(@Body() req:MonthWiseShrimpReq): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getShippedContainerMISDetails(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getGrnQuantityForMISReport')
    async getGrnQuantityForMISReport(@Body() req:MonthWiseShrimpReq): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getGrnQuantityForMISReport(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    
    @Post('/getMISproductDetailedReport')
    @ApiBody({type:ProductAnalysisReq})
    async getMISproductDetailedReport(@Body() req?:ProductAnalysisReq):Promise<CommonResponse>{
        try{
            return await this.warehouseService.getMISproductDetailedReport(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getGradesOpeningStockForProductionReport')
    async getGradesOpeningStockForProductionReport(@Body() req:ProductSummaryReportReq): Promise <CommonResponse> {
        console.log(req,"req controller")
        try {
            return await this.warehouseService.getGradesOpeningStockForProductionReport(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getProductionGradeInfoForProductionReport')
    async getProductionGradeInfoForProductionReport(@Body() req:ProductSummaryReportReq): Promise <CommonResponse> {
        console.log(req,"req controller")
        try {
            return await this.warehouseService.getProductionGradeInfoForProductionReport(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }


    @Post('/getShippedReprocessedGradeInfoForProductionReport')
    async getShippedReprocessedGradeInfoForProductionReport(@Body() req:ProductSummaryReportReq): Promise <CommonResponse> {
        console.log(req,"req controller")
        try {
            return await this.warehouseService.getShippedReprocessedGradeInfoForProductionReport(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getShortCodeDropdown')
    async getShortCodeDropdown(): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getShortCodeDropdown();
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getPackStyleForProductAnalysisReport')
    async getPackStyleForProductAnalysisReport(): Promise <CommonResponse> {
        try {
            return await this.warehouseService.getPackStyleForProductAnalysisReport();
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/updateMontlyMisInfo')
    async updateMontlyMisInfo():Promise<CommonResponse>{
        try{
            return await this.warehouseService.updateMontlyMisInfo()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/dayWiseProductionReport')
    async dayWiseProductionReport(@Body() req : DayWiseProductionReq):Promise<CommonResponse>{
        try{
            return await this.warehouseService.dayWiseProductionReport(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getMontlyMisInfo')
    async getMontlyMisInfo(@Body() req:MontlyMisInfoReq):Promise<CommonResponse>{
        try{
            return await this.warehouseService.getMontlyMisInfo(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getLotWiseReportInfo')
    async getLotWiseReportInfo(@Body() req:DateFilter):Promise<LotWiseInfoResponseModel>{
        try{
            return await this.warehouseService.getLotWiseReportInfo(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(LotWiseInfoResponseModel,err)
        }
    }

    @Post('/getAllLotNumbersDropdown')
    async getAllLotNumbersDropdown():Promise<CommonResponse>{
        try{
            return await this.warehouseService.getAllLotNumbersDropdown()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getSPSAStockValuationReport')
    async getSPSAStockValuationReport(@Body() req:SPSAStockValuationReq):Promise<CommonResponse>{
        try{
            return await this.warehouseService.getSPSAStockValuationReport(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getProductSkuDropdown')
    async getProductSkuDropdown():Promise<CommonResponse>{
        try{
            return await this.warehouseService.getProductSkuDropdown()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getCustomerPoDropdown')
    async getCustomerPoDropdown():Promise<CommonResponse>{
        try{
            return await this.warehouseService.getCustomerPoDropdown()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/getLotNumberDropdown')
    async getLotNumberDropdown():Promise<CommonResponse>{
        try{
            return await this.warehouseService.getLotNumberDropdown()
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }

    @Post('/createBaleAmtInfo')
    async createBaleAmtInfo(@Body() req:BaleReq):Promise<CommonResponse>{
        console.log('okkkkkkkkkkkkkkkkkkkkkk')
        try{
            return await this.warehouseService.createBaleAmtInfo(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse,err)
        }
    }
}
